import { BudgetPermissionLimits, PermissionCategory, PermissionLimitMapping } from "../../../http/protocol";
import { t } from "../../../i18n";
import { PermissionLimitType } from "./BudgetPermissionLimitsCard";
import BudgetPermissionsTh from "./BudgetPermissionLimitsTh";

interface BudgetPermissionsTableProps {
    limits: BudgetPermissionLimits;
    updateField: (category: PermissionLimitType, field: "dailyLimit" | "largeAmount", value: number) => void;
}

function BudgetPermissionsTable({ limits, updateField }: BudgetPermissionsTableProps) {
    const entries: Array<{ category: PermissionLimitType; limit: PermissionLimitMapping | undefined }> = [
        { category: PermissionCategory.BUDGET_SMALL, limit: limits.budgetSmall },
        { category: PermissionCategory.BUDGET_MEDIUM, limit: limits.budgetMedium },
        { category: PermissionCategory.BUDGET_LARGE, limit: limits.budgetLarge },
    ];

    return (
        <div className={"permissions-table-wrapper"}>
            <table className={"table table-striped permissions-table"}>
                <thead>
                    <tr>
                        <BudgetPermissionsTh labelText={t("budgetPermissionLimits.category")} />
                        <BudgetPermissionsTh labelText={t("budgetPermissionLimits.dailyLimit")} helpText={t("budgetPermissionLimits.dailyLimitHelp")} />
                        <BudgetPermissionsTh labelText={t("budgetPermissionLimits.largeAmount")} helpText={t("budgetPermissionLimits.largeAmountHelp")} />
                    </tr>
                </thead>
                <tbody>
                    {entries.map(({ category, limit }) => (
                        <tr key={category}>
                            <td>{category}</td>
                            <td>
                                <input
                                    type={"number"}
                                    className={"form-control"}
                                    min={0}
                                    value={limit?.dailyLimit}
                                    onChange={event => updateField(category, "dailyLimit", event.target.valueAsNumber)}
                                />
                            </td>
                            <td>
                                <input
                                    type={"number"}
                                    className={"form-control"}
                                    min={0}
                                    value={limit?.largeAmount}
                                    onChange={event => updateField(category, "largeAmount", event.target.valueAsNumber)}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default BudgetPermissionsTable;
